import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { RoutingService } from '@spartacus/core'
import { take } from 'rxjs'
import { CustomRoutes } from '../../../../../models/enum/custom-routes.enum'

@Component({
    selector: 'app-cancel-dispenser-agreement',
    templateUrl: './cancel-dispenser-agreement.component.html',
    styleUrl: './cancel-dispenser-agreement.component.scss',
    standalone: false
})
export class CancelDispenserAgreementComponent {
  public agreementNumber: string

  constructor(
    private routingService: RoutingService,
    private activedRoute: ActivatedRoute
  ) {
    this.activedRoute.url.pipe(take(1)).subscribe((url) => (this.agreementNumber = url[2].path))
  }

  public backToHistory(): void {
    this.routingService.go({ cxRoute: CustomRoutes.DISPENSER_AGREEMENT_HISTORY })
  }
}
